import { uniqueId } from 'lodash';

import {
  WorkflowStep,
  WorkflowStepActionKey,
  WorkflowStepType,
  WorkflowVersion,
  WorkflowVersionAttributes,
  WorkflowVersionRelationships,
  WorkflowVersionStatus,
} from 'dashboard/models/workflow-version';
import { ApiModel } from 'lib/interfaces/api';

export const generateWorkflowVersionId = () => uniqueId('wfv_');

export function createMockWorkflowVersion(
  attributes?: Partial<WorkflowVersionAttributes>,
  relationships?: Partial<WorkflowVersionRelationships>,
  id?: string,
): WorkflowVersion {
  return {
    attributes: {
      'updated-at': '',
      'created-at': '',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      description: null,
      output: { result: '' },
      'steps-config': [],
      status: WorkflowVersionStatus.Draft,
      'template-filters': [],
      ...attributes,
    },
    id: id || generateWorkflowVersionId(),
    relationships: {
      workflow: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      trigger: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      'active-deployment': {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      ...relationships,
    },
    type: ApiModel.WorkflowVersion,
  };
}

export function createMockWorkflowVersionV2(
  attributes?: Partial<WorkflowVersionAttributes>,
  relationships?: Partial<WorkflowVersionRelationships>,
  id?: string,
  stepsConfig?: WorkflowStep[],
): WorkflowVersion {
  return {
    attributes: {
      'updated-at': '',
      'created-at': '',
      'time-out-minutes': 60,
      description: undefined,
      enhanced: false,
      outputs: [],
      // (evan.qi) WARNING - if you change the default Create Case step below,
      // you will need to update many tests that do not provide their own steps
      // config and assert on this step.
      'steps-config': stepsConfig || [
        {
          type: WorkflowStepType.Action,
          name: 'Create Case A',
          token: 'token',
          action: {
            key: WorkflowStepActionKey.CreateCase,
            version: 1,
            params: {
              'case-objects': ['trigger'],
              'case-template-token': 'ctmpl_123',
              'case-fields': {},
            },
          },
        },
      ],
      status: WorkflowVersionStatus.Draft,
      'template-filters': [],
      ...attributes,
    },
    id: id || generateWorkflowVersionId(),
    relationships: {
      workflow: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      trigger: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      'active-deployment': {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      ...relationships,
    },
    type: ApiModel.WorkflowVersion,
  };
}
